/* Save as assets/hamamat-cart-fix.js.
   Requires the .hamamat-cart-recovery__form markup from cart-empty-recovery.liquid.
   Handles product-page hamamat-product-upsell .hu-form as well. */
(() => {
  const formSelector = '.hamamat-cart-recovery__form, hamamat-product-upsell .hu-form';
  const root = window.Shopify?.routes?.root || '/';
  const reopenKey = 'hamamat-reopen-cart-drawer';
  const shoppingUrl = document.currentScript?.dataset.shoppingUrl || `${root}collections/shop-all`;

  function fixShoppingLinks() {
    document.querySelectorAll('.cart-items__empty-button').forEach((link) => {
      if (link.getAttribute('href') !== shoppingUrl) link.href = shoppingUrl;
    });
  }
  fixShoppingLinks();
  let shoppingLinkUpdateScheduled = false;
  new MutationObserver(() => {
    if (shoppingLinkUpdateScheduled) return;
    shoppingLinkUpdateScheduled = true;
    requestAnimationFrame(() => {
      shoppingLinkUpdateScheduled = false;
      fixShoppingLinks();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  async function syncCartBadge() {
    const response = await fetch(`${root}cart.js`, {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });
    if (!response.ok) throw new Error('Could not load the cart count.');
    const cart = await response.json();
    const count = Number(cart.item_count) || 0;
    document.querySelectorAll('.cart-bubble').forEach((bubble) => {
      const countElement = bubble.querySelector('.cart-bubble__text-count');
      if (countElement) {
        countElement.textContent = String(count);
        countElement.classList.toggle('hidden', count === 0);
      }
      bubble.classList.toggle('visually-hidden', count === 0);
    });
    return cart;
  }

  function showError(form, message) {
    let status = form.querySelector('[data-cart-add-error]');
    if (!status) {
      status = document.createElement('span');
      status.dataset.cartAddError = '';
      status.setAttribute('role', 'alert');
      form.append(status);
    }
    status.textContent = message;
  }

  // Reload renders the correct cart contents. Open it using the header's native
  // on:click="#cart-drawer/toggle" control; cart-drawer-component.open is a Boolean.
  window.addEventListener('load', async () => {
    const shouldOpen = sessionStorage.getItem(reopenKey) === location.pathname;
    sessionStorage.removeItem(reopenKey);
    try {
      const cart = await syncCartBadge();
      if (!shouldOpen || cart.item_count < 1) return;
      const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      const dialog = document.querySelector('#cart-drawer dialog');
      if (trigger && !dialog?.open) trigger.click();
    } catch (error) {
      console.error('Cart refresh failed:', error);
      if (shouldOpen) {
        document.querySelector('[data-testid="cart-drawer-trigger"]')?.click();
      }
    }
  }, { once: true });

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches(formSelector)) return;
    event.preventDefault();

    const button = event.submitter || form.querySelector('[type="submit"]');
    if (button?.disabled) return;
    const fields = new FormData(form);
    if (!fields.get('id')) {
      showError(form, 'Please select a variant before adding this product.');
      return;
    }
    if (button) button.disabled = true;
    form.querySelector('[data-cart-add-error]')?.remove();

    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: fields,
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Could not add this item.');

      // Horizon omits the drawer on /cart. A reload renders the updated cart page.
      const onCartPage = location.pathname.replace(/\/$/, '') === `${root}cart`.replace(/\/$/, '');
      if (!onCartPage && document.querySelector('#cart-drawer')) {
        sessionStorage.setItem(reopenKey, location.pathname);
      }
      location.reload();
    } catch (error) {
      showError(form, error.message || 'Unable to add this product. Please try again.');
      if (button) button.disabled = false;
    }
  });
})();
